/**
 * Normal Slider
 */

export default function ListSlider() {
    const selectors = {
        'slider' : '[data-swiper="list"]',
        'bookmarkSlider': '[data-swiper="bookmarkSlider"]',
        'widthSlider' : '[data-value-swiper="width"]',
        'groupSlider' : '[data-group-swiper="topics"]',
        'groupSlider2' : '[data-group-swiper="topics-2"]',
        'groupSliderRelated' : '[data-group-swiper="topics-related"]',
    };

    this.init = () => {
        this.slide();
    };

    this.slide = () => {
        if (typeof Swiper == 'function') {
            jQuery(selectors.slider).each((index, item) => {
                let $this = jQuery(item);
                let json = $this.data("swiper_json");
                new Swiper($this.get(0), json);
            })


            jQuery(selectors.bookmarkSlider).each((index, item) => {
                let $this = jQuery(item);
                let $sectionParent = $this.closest('section');

                // Initialize Swiper for image
                let $slideImg = $sectionParent.find('[data-slide-image="bookmarkSlider"]');
                $slideImg.css('width', $slideImg.width() + 'px');

                let swImg = new Swiper($slideImg.get(0), {
                    slidesPerView: 1,
                    spaceBetween: 10,
                    allowTouchMove: false,
                });

                // Initialize Swiper for content
                let $slideContent = $sectionParent.find('[data-slide-text="bookmarkSlider"]');
                $slideContent.css('width', $slideContent.width() + 'px');

                let swContent = new Swiper($slideContent.get(0), {
                    slidesPerView: 1,
                    spaceBetween: 16,
                    allowTouchMove: false,
                    thumbs: {
                        swiper: swImg,
                    },
                });

                // Swiper Configuration
                let json = {
                    direction: 'vertical',
                    slidesPerView: 3,
                    spaceBetween: 16,
                    centeredSlides: true,
                    slideToClickedSlide: true,
                    navigation: {
                        'nextEl': '[data-group-swiper="bookmarkSlider"] .swiper-button-next',
                        'prevEl': '[data-group-swiper="bookmarkSlider"] .swiper-button-prev'
                    },

                    thumbs: {
                        swiper: swContent,
                    },

                    breakpoints: {
                        320: {
                            direction: 'horizontal',
                            slidesPerView: 1,
                        },
                        768: {
                            direction: 'vertical',
                            slidesPerView: 3,
                        }
                    }
                };
                new Swiper($this.get(0), json);                
            })

            jQuery(selectors.widthSlider).each((index, item) => {
                let $this = jQuery(item);
                $this.css('--wsw', $this.width() + 'px');

                jQuery(window).on('resize', function() {
                    $this.css('--wsw', $this.width() + 'px');
                });
            })

            jQuery(selectors.groupSlider).each((index, item) => {
                let $this = jQuery(item);
                let $swiper = $this.find('.swiper');
                
                let json = {
                    'slidesPerView': 1,
                    'spaceBetween': 60,
                    'centeredSlides': 0,
                    'pagination': {
                        'el': '.swiper-pagination',
                        'type': 'bullets'
                    },
                    'navigation': {
                        'nextEl': '.swiper-button-next',
                        'prevEl': '.swiper-button-prev'
                    },
                    'breakpoints': {
                        0: {
                            'direction': 'horizontal',
                            'slidesPerView': 1,
                            'spaceBetween': 40,
                        },
                        768: {
                            'direction': 'horizontal',
                            'slidesPerView': 2.2,
                            'spaceBetween': 20,
                        },
                        1025: {
                            'direction': 'horizontal',
                            'slidesPerView': 2.5,
                            'spaceBetween': 40,
                        },
                        1281: {
                            'direction': 'horizontal',
                            'slidesPerView': 3,
                            'spaceBetween': 60,
                        }
                    }
                };

                json['navigation'] = {
                    'nextEl': $this.find(json['navigation']['nextEl']).get(0),
                    'prevEl': $this.find(json['navigation']['prevEl']).get(0),
                }

                new Swiper($swiper.get(0), json);
            })

            jQuery(selectors.groupSlider2).each((index, item) => {
                let $this = jQuery(item);
                let $swiper = $this.find('.swiper');
                
                let json = {
                    'slidesPerView': 1,
                    'spaceBetween': 60,
                    'centeredSlides': 0,
                    'pagination': {
                        'el': '.swiper-pagination',
                        'type': 'bullets'
                    },
                    'navigation': {
                        'nextEl': '.swiper-button-next',
                        'prevEl': '.swiper-button-prev'
                    },
                    'breakpoints': {
                        0: {
                            'direction': 'vertical',
                            'slidesPerView': 'auto',
                            'spaceBetween': 40,
                        },
                        768: {
                            'direction': 'horizontal',
                            'slidesPerView': 2.2,
                            'spaceBetween': 20,
                        },
                        1025: {
                            'direction': 'horizontal',
                            'slidesPerView': 2.5,
                            'spaceBetween': 40,
                        },
                        1281: {
                            'direction': 'horizontal',
                            'slidesPerView': 3,
                            'spaceBetween': 60,
                        }
                    }
                };

                json['navigation'] = {
                    'nextEl': $this.find(json['navigation']['nextEl']).get(0),
                    'prevEl': $this.find(json['navigation']['prevEl']).get(0),
                }

                new Swiper($swiper.get(0), json);
            })
            
            jQuery(selectors.groupSliderRelated).each((index, item) => {
                let $this = jQuery(item);
                let $swiper = $this.find('.swiper');
                
                let json = {
                    'slidesPerView': 1,
                    'spaceBetween': 60,
                    'centeredSlides': 0,
                    'pagination': {
                        'el': '.swiper-pagination',
                        'type': 'bullets'
                    },
                    'navigation': {
                        'nextEl': '.swiper-button-next',
                        'prevEl': '.swiper-button-prev'
                    },
                    'breakpoints': {
                        0: {
                            'direction': 'vertical',
                            'slidesPerView': 'auto',
                            'spaceBetween': 40,
                        },
                        768: {
                            'direction': 'horizontal',
                            'slidesPerView': 2.2,
                            'spaceBetween': 20,
                        },
                        1025: {
                            'direction': 'horizontal',
                            'slidesPerView': 2.5,
                            'spaceBetween': 40,
                        },
                        1281: {
                            'direction': 'horizontal',
                            'slidesPerView': 3,
                            'spaceBetween': 60,
                        }
                    }
                };

                json['navigation'] = {
                    'nextEl': $this.find(json['navigation']['nextEl']).get(0),
                    'prevEl': $this.find(json['navigation']['prevEl']).get(0),
                }

                new Swiper($swiper.get(0), json);
            })
        }
    }

}
